import { useRef } from 'react';

/**
 * Creates ref and rewrites its value with the passed one before each render.
 * Can be used to get the actual value inside effects.
 * @NOTICE instead of `useLastValueRef` in packages/vc-web/src/js/utils/hooks.ts.
 */
export function useLastValueRef<T>(value: T): { readonly current: T } {
    const ref = useRef<T>(value);
    ref.current = value;
    return ref;
}
